import React from "react";
import { IoAddCircleOutline } from "react-icons/io5";

const CreateBtn = () => {
	return (
		<div className="box-border relative z-30 inline-flex items-center justify-center w-auto px-8 py-3 overflow-hidden font-bold text-white transition-all duration-300 rounded-full cursor-pointer group ease focus:outline-none create-btn-gradient">
			<span className="absolute bottom-0 right-0 w-8 h-20 -mb-8 -mr-5 transition-all duration-300 ease-out transform rotate-45 translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
			<span className="absolute top-0 left-0 w-20 h-8 -mt-1 -ml-12 transition-all duration-300 ease-out transform -rotate-45 -translate-x-1 bg-white opacity-10 group-hover:translate-x-0"></span>
			<span className="relative z-20 flex items-center gap-2 text-sm">
				<IoAddCircleOutline className="text-lg" />
				Create Post
			</span>
		</div>
	);
};

export default CreateBtn;
